// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yUWi","largestCol":"styles_largestCol__Tqe7C","smallestCol":"styles_smallestCol__11shr"};